import { BaseStyle } from './styled';
export function StyleReset() {
    return <BaseStyle />;
}
